import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { identity, normalizeReturnTo } from '../../chronicles-ui/identity';
import assets from '../../chronicles-ui/assets.json';
import './Login.css';

const Login = () => {
    const { status } = useAuth();
    const navigate = useNavigate();
    const returnTo = normalizeReturnTo(new URLSearchParams(window.location.search).get('returnTo'));
    const failed = new URLSearchParams(window.location.search).has('error');

    useEffect(() => {
        if (status === 'authenticated') {
            const target = identity.takeCallbackTarget();
            if (target !== null) {
                if (/^\/(?:wiki|w|plot)(?:\/|$)/.test(target)) window.location.replace(target);
                else navigate(target, { replace: true });
            }
        }
    }, [status, navigate]);

    const handleDiscordLogin = () => identity.loginWithDiscord(returnTo);

    return (
        <div className="login-page">
            <div className="signin-card">
                <img className="signin-logo" src={assets.logos.kobold.url} alt="Chronicles" />
                <h1 className="signin-title">Sign in to Chronicles</h1>
                <p className="signin-subtitle">Choose how you'd like to sign in</p>
                {failed && <p role="alert">Sign-in failed. Please try again.</p>}

                <div className="signin-providers">
                    <button
                        type="button"
                        className="provider-btn provider-discord"
                        onClick={handleDiscordLogin}
                    >
                        <svg className="provider-icon" viewBox="0 0 24 24" aria-hidden="true">
                            <path d="M20.317 4.369a19.79 19.79 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128c.126-.094.252-.192.372-.291a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.009c.12.099.246.198.373.292a.077.077 0 0 1-.006.127 12.3 12.3 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.84 19.84 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.331c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"/>
                        </svg>
                        <span>Sign in with Discord</span>
                    </button>
                </div>

                <p className="signin-footnote">
                    Just browsing?{' '}
                    <span className="signin-link" onClick={() => navigate('/schedule')}>
                        View the event schedule
                    </span>
                </p>
            </div>
        </div>
    );
};

export default Login;
